// // *************************************** ajay:code 12-08-26
// import { useState, useEffect, useCallback } from "react";
// import { Eye, EyeOff, Pencil, Power, X } from "lucide-react";
// import { clientUserAPI } from "../../services/api";

// const PAGE_OPTIONS = [
//   { key: "dashboard", label: "Dashboard" },
//   { key: "weight_history", label: "Weight History" },
//   { key: "pdir", label: "PDIR Reports" },
//   { key: "fpir", label: "FPIR Reports" },
//   { key: "pfmea", label: "PFMEA Reports" },
//   { key: "control-plan", label: "Control Plan" },
// ];

// export default function ClientUsers() {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showModal, setShowModal] = useState(false);
//   const [editing, setEditing] = useState(null); // the row being configured/edited
//   const [saving, setSaving] = useState(false);
//   const [err, setErr] = useState("");

//   const [password, setPassword] = useState("");
//   const [showPass, setShowPass] = useState(false);
//   const [pages, setPages] = useState([]);

//   const load = useCallback(() => {
//     setLoading(true);
//     clientUserAPI
//       .listLinked()
//       .then((r) => setRows(r.data || []))
//       .finally(() => setLoading(false));
//   }, []);

//   useEffect(() => {
//     load();
//   }, [load]);

//   const openConfigure = (row) => {
//     setEditing(row);
//     setPassword("");
//     setPages(row.protected_pages || []);
//     setErr("");
//     setShowModal(true);
//   };

//   const togglePage = (key) => {
//     setPages((prev) =>
//       prev.includes(key) ? prev.filter((p) => p !== key) : [...prev, key],
//     );
//   };

//   const submit = async () => {
//     setErr("");
//     if (!editing.configured && !password.trim()) {
//       return setErr(
//         "Access password is required the first time you configure this user",
//       );
//     }
//     setSaving(true);
//     try {
//       const payload = { protected_pages: pages };
//       if (password.trim()) payload.access_password = password;
//       await clientUserAPI.updateAccess(editing.client_user_id, payload);
//       setShowModal(false);
//       load();
//     } catch (e) {
//       setErr(e.data?.message || e.message || "Failed to save");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggle = async (row) => {
//     if (!row.configured) return; // nothing to toggle until configured once
//     await clientUserAPI.toggleLink(row.client_user_id);
//     load();
//   };

//   return (
//     <div style={{ padding: 28 }}>
//       <div style={{ marginBottom: 24 }}>
//         <h1 style={{ fontSize: 20, fontWeight: 700 }}>Client Users</h1>
//         <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
//           Client users belonging to your assigned client organisation(s) — set
//           an access password and choose which pages they need it for.
//         </p>
//       </div>

//       <div className="card" style={{ padding: 0, overflow: "hidden" }}>
//         {loading ? (
//           <div
//             style={{ padding: 24, textAlign: "center", color: "var(--text2)" }}
//           >
//             Loading...
//           </div>
//         ) : (
//           <table>
//             <thead>
//               <tr>
//                 <th>Name</th>
//                 <th>Email</th>
//                 <th>Protected Pages</th>
//                 <th>Status</th>
//                 <th>Last Login</th>
//                 <th style={{ width: 90 }}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {rows.length === 0 && (
//                 <tr>
//                   <td
//                     colSpan={6}
//                     style={{
//                       textAlign: "center",
//                       padding: 20,
//                       color: "var(--text3)",
//                     }}
//                   >
//                     No client users found — Superadmin must first assign a
//                     client organisation to your company, and create users under
//                     it.
//                   </td>
//                 </tr>
//               )}
//               {rows.map((r) => (
//                 <tr key={r.client_user_id}>
//                   <td style={{ fontWeight: 500 }}>{r.name}</td>
//                   <td className="text2">{r.email}</td>
//                   <td>
//                     {r.protected_pages?.length > 0 ? (
//                       <div
//                         style={{ display: "flex", flexWrap: "wrap", gap: 4 }}
//                       >
//                         {r.protected_pages.map((p) => (
//                           <span
//                             key={p}
//                             className="badge badge-danger"
//                             style={{ fontSize: 10 }}
//                           >
//                             {PAGE_OPTIONS.find((o) => o.key === p)?.label || p}
//                           </span>
//                         ))}
//                       </div>
//                     ) : (
//                       <span className="text3" style={{ fontSize: 12 }}>
//                         {r.configured ? "None (fully open)" : "—"}
//                       </span>
//                     )}
//                   </td>
//                   <td>
//                     <span
//                       className={`badge ${r.link_status === "Active" ? "badge-success" : r.link_status === "Not Configured" ? "badge-danger" : "badge-danger"}`}
//                     >
//                       {r.link_status}
//                     </span>
//                   </td>
//                   <td className="text2" style={{ fontSize: 12 }}>
//                     {r.last_login
//                       ? new Date(r.last_login).toLocaleString()
//                       : "—"}
//                   </td>
//                   <td>
//                     <div style={{ display: "flex", gap: 6 }}>
//                       <button
//                         title={
//                           r.configured ? "Edit access" : "Configure access"
//                         }
//                         onClick={() => openConfigure(r)}
//                         style={iconBtn}
//                       >
//                         <Pencil size={13} />
//                       </button>
//                       {r.configured && (
//                         <button
//                           title="Toggle status"
//                           onClick={() => toggle(r)}
//                           style={iconBtn}
//                         >
//                           <Power size={13} />
//                         </button>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>

//       {showModal && (
//         <div
//           onClick={() => setShowModal(false)}
//           style={{
//             position: "fixed",
//             inset: 0,
//             background: "rgba(0,0,0,0.6)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 999,
//             padding: 20,
//           }}
//         >
//           <div
//             onClick={(e) => e.stopPropagation()}
//             className="card"
//             style={{
//               maxWidth: 440,
//               width: "100%",
//               maxHeight: "85vh",
//               overflow: "auto",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 marginBottom: 18,
//               }}
//             >
//               <h3 style={{ fontSize: 15, fontWeight: 700 }}>
//                 {editing?.configured ? "Edit Access" : "Configure Access"} —{" "}
//                 {editing?.name}
//               </h3>
//               <button
//                 onClick={() => setShowModal(false)}
//                 style={{
//                   background: "none",
//                   border: "none",
//                   cursor: "pointer",
//                   color: "var(--text2)",
//                 }}
//               >
//                 <X size={18} />
//               </button>
//             </div>

//             {err && (
//               <div
//                 style={{
//                   color: "var(--danger)",
//                   fontSize: 12,
//                   marginBottom: 14,
//                 }}
//               >
//                 {err}
//               </div>
//             )}

//             <div className="form-group" style={{ marginBottom: 14 }}>
//               <label>
//                 Access Password
//                 {editing?.configured && (
//                   <span style={{ color: "var(--text3)", fontWeight: 400 }}>
//                     {" "}
//                     (leave blank to keep current)
//                   </span>
//                 )}
//               </label>
//               <div style={{ position: "relative" }}>
//                 <input
//                   type={showPass ? "text" : "password"}
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder={
//                     editing?.configured
//                       ? "Leave blank to keep existing"
//                       : "Set a password"
//                   }
//                   style={{ paddingRight: 36 }}
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPass(!showPass)}
//                   style={{
//                     position: "absolute",
//                     right: 10,
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     background: "none",
//                     border: "none",
//                     color: "var(--text3)",
//                     cursor: "pointer",
//                     display: "flex",
//                   }}
//                 >
//                   {showPass ? <EyeOff size={14} /> : <Eye size={14} />}
//                 </button>
//               </div>
//             </div>

//             <div className="form-group" style={{ marginBottom: 18 }}>
//               <label>
//                 Protected Pages{" "}
//                 <span style={{ color: "var(--text3)", fontWeight: 400 }}>
//                   (only checked pages require the password)
//                 </span>
//               </label>
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: 8,
//                   marginTop: 6,
//                 }}
//               >
//                 {PAGE_OPTIONS.map((opt) => (
//                   <label
//                     key={opt.key}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 8,
//                       fontSize: 13,
//                       cursor: "pointer",
//                     }}
//                   >
//                     <input
//                       type="checkbox"
//                       checked={pages.includes(opt.key)}
//                       onChange={() => togglePage(opt.key)}
//                       style={{ width: 15, height: 15, cursor: "pointer" }}
//                     />
//                     {opt.label}
//                   </label>
//                 ))}
//               </div>
//             </div>

//             <button
//               className="btn-primary"
//               onClick={submit}
//               disabled={saving}
//               style={{ width: "100%" }}
//             >
//               {saving
//                 ? "Saving..."
//                 : editing?.configured
//                   ? "Save Changes"
//                   : "Save & Configure"}
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// const iconBtn = {
//   background: "var(--surface2)",
//   border: "1px solid var(--border2)",
//   borderRadius: 6,
//   padding: 5,
//   cursor: "pointer",
//   color: "var(--text2)",
//   display: "flex",
// };

// 28-09-26
import { useState, useEffect, useCallback } from "react";
import { Eye, EyeOff, Pencil, Power, X } from "lucide-react";
import { clientUserAPI } from "../../services/api";

const PAGE_OPTIONS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "weight_history", label: "Weight History" },
  { key: "pdir", label: "PDIR Reports" },
  { key: "fpir", label: "FPIR Reports" },
  { key: "pfmea", label: "PFMEA Reports" },
  { key: "control-plan", label: "Control Plan" },
];

// protected_pages can arrive as a JSON string from some DB setups — always normalise to an array
const toPagesArray = (v) => {
  let x = v;
  for (let i = 0; i < 2 && typeof x === "string"; i++) {
    try {
      x = JSON.parse(x);
    } catch (e) {
      return [];
    }
  }
  return Array.isArray(x) ? x : [];
};

export default function ClientUsers() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null); // the row being configured/edited
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [pages, setPages] = useState([]);

  const load = useCallback(() => {
    setLoading(true);
    clientUserAPI
      .listLinked()
      .then((r) => setRows(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const openConfigure = (row) => {
    setEditing(row);
    setPassword("");
    setPages(toPagesArray(row.protected_pages));
    setErr("");
    setShowModal(true);
  };

  const togglePage = (key) => {
    setPages((prev) =>
      prev.includes(key) ? prev.filter((p) => p !== key) : [...prev, key],
    );
  };

  const submit = async () => {
    setErr("");
    if (!editing.configured && !password.trim()) {
      return setErr(
        "Access password is required the first time you configure this user",
      );
    }
    setSaving(true);
    try {
      const payload = { protected_pages: pages };
      if (password.trim()) payload.access_password = password;
      await clientUserAPI.updateAccess(editing.client_user_id, payload);
      setShowModal(false);
      load();
    } catch (e) {
      setErr(e.data?.message || e.message || "Failed to save");
    } finally {
      setSaving(false);
    }
  };

  const toggle = async (row) => {
    if (!row.configured) return; // nothing to toggle until configured once
    await clientUserAPI.toggleLink(row.client_user_id);
    load();
  };

  return (
    <div style={{ padding: 28 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 20, fontWeight: 700 }}>Client Users</h1>
        <p style={{ color: "var(--text2)", fontSize: 13, marginTop: 2 }}>
          Client users belonging to your assigned client organisation(s) — set
          an access password and choose which pages they need it for.
        </p>
      </div>

      <div className="card" style={{ padding: 0, overflow: "hidden" }}>
        {loading ? (
          <div
            style={{ padding: 24, textAlign: "center", color: "var(--text2)" }}
          >
            Loading...
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Protected Pages</th>
                <th>Status</th>
                <th>Last Login</th>
                <th style={{ width: 90 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && (
                <tr>
                  <td
                    colSpan={6}
                    style={{
                      textAlign: "center",
                      padding: 20,
                      color: "var(--text3)",
                    }}
                  >
                    No client users found — Superadmin must first assign a
                    client organisation to your company, and create users under
                    it.
                  </td>
                </tr>
              )}
              {rows.map((r) => (
                <tr key={r.client_user_id}>
                  <td style={{ fontWeight: 500 }}>{r.name}</td>
                  <td className="text2">{r.email}</td>
                  <td>
                    {toPagesArray(r.protected_pages).length > 0 ? (
                      <div
                        style={{ display: "flex", flexWrap: "wrap", gap: 4 }}
                      >
                        {toPagesArray(r.protected_pages).map((p) => (
                          <span
                            key={p}
                            className="badge badge-danger"
                            style={{ fontSize: 10 }}
                          >
                            {PAGE_OPTIONS.find((o) => o.key === p)?.label || p}
                          </span>
                        ))}
                      </div>
                    ) : (
                      <span className="text3" style={{ fontSize: 12 }}>
                        {r.configured ? "None (fully open)" : "—"}
                      </span>
                    )}
                  </td>
                  <td>
                    <span
                      className={`badge ${r.link_status === "Active" ? "badge-success" : r.link_status === "Not Configured" ? "badge-danger" : "badge-danger"}`}
                    >
                      {r.link_status}
                    </span>
                  </td>
                  <td className="text2" style={{ fontSize: 12 }}>
                    {r.last_login
                      ? new Date(r.last_login).toLocaleString()
                      : "—"}
                  </td>
                  <td>
                    <div style={{ display: "flex", gap: 6 }}>
                      <button
                        title={
                          r.configured ? "Edit access" : "Configure access"
                        }
                        onClick={() => openConfigure(r)}
                        style={iconBtn}
                      >
                        <Pencil size={13} />
                      </button>
                      {r.configured && (
                        <button
                          title="Toggle status"
                          onClick={() => toggle(r)}
                          style={iconBtn}
                        >
                          <Power size={13} />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999,
            padding: 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="card"
            style={{
              maxWidth: 440,
              width: "100%",
              maxHeight: "85vh",
              overflow: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 18,
              }}
            >
              <h3 style={{ fontSize: 15, fontWeight: 700 }}>
                {editing?.configured ? "Edit Access" : "Configure Access"} —{" "}
                {editing?.name}
              </h3>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "var(--text2)",
                }}
              >
                <X size={18} />
              </button>
            </div>

            {err && (
              <div
                style={{
                  color: "var(--danger)",
                  fontSize: 12,
                  marginBottom: 14,
                }}
              >
                {err}
              </div>
            )}

            <div className="form-group" style={{ marginBottom: 14 }}>
              <label>
                Access Password
                {editing?.configured && (
                  <span style={{ color: "var(--text3)", fontWeight: 400 }}>
                    {" "}
                    (leave blank to keep current)
                  </span>
                )}
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPass ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={
                    editing?.configured
                      ? "Leave blank to keep existing"
                      : "Set a password"
                  }
                  style={{ paddingRight: 36 }}
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    color: "var(--text3)",
                    cursor: "pointer",
                    display: "flex",
                  }}
                >
                  {showPass ? <EyeOff size={14} /> : <Eye size={14} />}
                </button>
              </div>
            </div>

            <div className="form-group" style={{ marginBottom: 18 }}>
              <label>
                Protected Pages{" "}
                <span style={{ color: "var(--text3)", fontWeight: 400 }}>
                  (only checked pages require the password)
                </span>
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  marginTop: 6,
                }}
              >
                {PAGE_OPTIONS.map((opt) => (
                  <label
                    key={opt.key}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      fontSize: 13,
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={pages.includes(opt.key)}
                      onChange={() => togglePage(opt.key)}
                      style={{ width: 15, height: 15, cursor: "pointer" }}
                    />
                    {opt.label}
                  </label>
                ))}
              </div>
            </div>

            <button
              className="btn-primary"
              onClick={submit}
              disabled={saving}
              style={{ width: "100%" }}
            >
              {saving
                ? "Saving..."
                : editing?.configured
                  ? "Save Changes"
                  : "Save & Configure"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const iconBtn = {
  background: "var(--surface2)",
  border: "1px solid var(--border2)",
  borderRadius: 6,
  padding: 5,
  cursor: "pointer",
  color: "var(--text2)",
  display: "flex",
};
